/* tslint:disable */

declare var Object: any;
export interface RoleInterface {
  "id"?: any;
  "name": string;
  "description"?: string;
  "created"?: Date;
  "modified"?: Date;
  "hierarchy"?: number;
  "displayName"?: string;
  principals?: any[];
}

export class Role implements RoleInterface {
  "id": any;
  "name": string;
  "description": string;
  "created": Date;
  "modified": Date;
  "hierarchy": number;
  "displayName": string;
  principals: any[];
  constructor(data?: RoleInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Role`.
   */
  public static getModelName() {
    return "Role";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Role for dynamic purposes.
  **/
  public static factory(data: RoleInterface): Role{
    return new Role(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Role',
      plural: 'Roles',
      path: 'Roles',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'any'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "created": {
          name: 'created',
          type: 'Date'
        },
        "modified": {
          name: 'modified',
          type: 'Date'
        },
        "hierarchy": {
          name: 'hierarchy',
          type: 'number'
        },
        "displayName": {
          name: 'displayName',
          type: 'string'
        },
      },
      relations: {
        principals: {
          name: 'principals',
          type: 'any[]',
          model: '',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'roleId'
        },
      }
    }
  }
}
